export const PRESETS_VERSION = 1
const MAX_NAME = 60
const MAX_PRESETS = 50

export function makePresetId() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID()
  } catch {}
  return `p_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
}

export function normalizePresets(value) {
  const list = Array.isArray(value) ? value : []
  const seen = new Set()
  const result = []
  let defaultId = null
  for (const item of list) {
    if (!item || typeof item !== 'object') continue
    const id = typeof item.id === 'string' && item.id ? item.id : null
    if (!id || seen.has(id)) continue
    seen.add(id)
    const name = String(item.name ?? '').trim().slice(0, MAX_NAME)
    if (!name) continue
    const snapshot = item.snapshot && typeof item.snapshot === 'object' ? item.snapshot : {}
    const isDefault = item.isDefault === true
    if (isDefault && !defaultId) defaultId = id
    result.push({ id, name, snapshot, isDefault: defaultId === id })
    if (result.length >= MAX_PRESETS) break
  }
  return result
}

export function loadPresets(storage, key) {
  try {
    const parsed = JSON.parse(storage?.getItem(key) || 'null')
    return parsed?.version === PRESETS_VERSION ? normalizePresets(parsed.value) : []
  } catch {
    return []
  }
}

export function savePresets(storage, key, presets) {
  try {
    storage?.setItem(key, JSON.stringify({ version: PRESETS_VERSION, value: presets }))
  } catch {
    return undefined
  }
  return presets
}

export function createPreset(name, snapshot) {
  return {
    id: makePresetId(),
    name: String(name ?? '').trim().slice(0, MAX_NAME),
    snapshot: snapshot && typeof snapshot === 'object' ? snapshot : {},
    isDefault: false,
  }
}

export function snapshotKey(snapshot) {
  if (!snapshot || typeof snapshot !== 'object') return ''
  try {
    return JSON.stringify(snapshot)
  } catch {
    return ''
  }
}

export function normalizeName(name) {
  return String(name ?? '').trim().slice(0, MAX_NAME)
}
